import type { User } from '@doccareplus/kernel/domain';
import type { ActiveClinicContext, ClinicMembershipState } from '@doccareplus/kernel/application/store/slices/auth.slice';

export function needsPhoneVerification(user: User | null): boolean {
  return !!user && (user.userType === 'Owner' || user.userType === 'Staff') && !user.isPhoneVerified;
}

export function needsOnboarding(
  memberships: ClinicMembershipState[],
  activeContext: ActiveClinicContext | null
): boolean {
  const membership = memberships.find((item) => item.clinicId === activeContext?.clinicId)
    ?? (memberships.length === 1 ? memberships[0] : undefined);
  return !!membership && membership.isOnboardingComplete !== true;
}

export function onboardingRedirectTarget(
  pathname: string,
  memberships: ClinicMembershipState[],
  activeContext: ActiveClinicContext | null
): string | null {
  const activeMembership = memberships.find((membership) => membership.clinicId === activeContext?.clinicId)
    ?? (memberships.length === 1 ? memberships[0] : undefined);

  if (needsOnboarding(memberships, activeContext) && pathname !== '/onboarding') {
    return '/onboarding';
  }

  if (activeMembership?.isOnboardingComplete === true && pathname === '/onboarding') {
    // Optional setup moved to the dashboard's "Clinic setup health" card — go straight to the workspace.
    return '/dashboard';
  }

  return null;
}
